"use client";

import { Contrast } from "lucide-react";
import { useAccessibility } from "@/lib/accessibility";
import { cn } from "@/lib/utils";

interface AccessibilityControlsProps {
  className?: string;
  size?: "sm" | "md";
}

export function AccessibilityControls({ className, size = "sm" }: AccessibilityControlsProps) {
  const { highContrast, increaseFont, decreaseFont, canIncrease, canDecrease, toggleContrast } =
    useAccessibility();

  const btn = size === "md" ? "h-10 w-10 text-body-sm" : "h-7 w-7 text-body-xs";

  return (
    // biome-ignore lint/a11y/useSemanticElements: role=group no lugar de <fieldset> — o avaliador AMAWeb tem falso-positivo em fieldset/legend
    <div
      role="group"
      aria-label="Acessibilidade"
      className={cn("flex items-center gap-1", className)}
    >
      <button
        type="button"
        onClick={increaseFont}
        disabled={!canIncrease}
        aria-label="Aumentar tamanho da fonte"
        className={cn(
          "inline-flex items-center justify-center rounded-md font-semibold transition-colors hover:bg-current/10 disabled:opacity-40 disabled:hover:bg-transparent",
          btn,
        )}
      >
        A+
      </button>
      <button
        type="button"
        onClick={decreaseFont}
        disabled={!canDecrease}
        aria-label="Diminuir tamanho da fonte"
        className={cn(
          "inline-flex items-center justify-center rounded-md font-semibold transition-colors hover:bg-current/10 disabled:opacity-40 disabled:hover:bg-transparent",
          btn,
        )}
      >
        A−
      </button>
      <button
        type="button"
        onClick={toggleContrast}
        aria-pressed={highContrast}
        aria-label={highContrast ? "Desativar alto contraste" : "Ativar alto contraste"}
        className={cn(
          "inline-flex items-center justify-center rounded-md transition-colors hover:bg-current/10",
          btn,
        )}
      >
        <Contrast aria-hidden className={size === "md" ? "h-5 w-5" : "h-4 w-4"} />
      </button>
    </div>
  );
}
